import Head from 'next/head';
import React from 'react';

/**
 * These tags should always come first in the head block as they must be in the first 512 bytes of the file.
 * * Charset / encoding
 * * Title
 * * Robots
 * * viewport
 */
const createPrimaryHeadTags = () => (
    <>
        <meta charSet="utf-8" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta key="robots" name="robots" content="index,follow" />
        <title key="title">Fairygodboss</title>
        <meta name="application-name" content="Fairygodboss" />
    </>
);

/**
 * Preconnect to third-party domains that we know for sure will be requested.
 */
const createPreConnectTags = () => (
    <>
        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <link rel="preconnect" href="https://www.google-analytics.com" />
        <link rel="preconnect" href="https://d207ibygpg2z1x.cloudfront.net" />
    </>
);

/**
 * Third party verification metadata.
 */
const createVerificationTags = () => (
    <>
        <meta
            name="google-site-verification"
            content="oNYMpG6PBkvJGNNBI0yZ8Lrb9GdvJczImLat8NQEHX8"
        />
        <meta name="msvalidate.01" content="9D58CAD1C532572C633D62624F20F702" />
        <meta
            name="p:domain_verify"
            content="7ad6ff4b66cfa84eefb9509c3e7cafed"
        />
    </>
);

/**
 * Social Media tags come dead last in the head.
 */
const createSocialMediaTags = () => (
    <>
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="Fairygodboss" />
        <meta
            property="og:see_also"
            content="https://github.com/fairyGodBoss/"
        />
        <meta
            property="og:see_also"
            content="https://www.instagram.com/fairygodboss/"
        />
        <meta
            property="og:see_also"
            content="https://www.pinterest.com/fairygodboss/"
        />
        <meta
            property="og:see_also"
            content="https://twitter.com/fairygodboss"
        />
        <meta
            property="og:see_also"
            content="https://www.facebook.com/fairygodboss/"
        />
        <meta
            property="og:see_also"
            content="https://www.linkedin.com/company/fairygodboss/"
        />
        <meta
            property="og:see_also"
            content="https://www.youtube.com/channel/UCA_fbeNmeWwMtbQwF7gjMXg"
        />
        <meta
            property="fb:app_id"
            content={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
        />
        <meta name="twitter:card" content="summary" key="twitterSummary" />
        <link
            rel="icon"
            type="img/png"
            href="https://cf-cdn.fairygodboss.com/static-assets/img/favicon.png"
        />
    </>
);

const Seo = () => (
    <Head>
        {createPrimaryHeadTags()}
        {createPreConnectTags()}
        {createVerificationTags()}
        {createSocialMediaTags()}
    </Head>
);

export default Seo;
